<script setup lang="ts">
import { useAuthStore } from '@/stores/auth'
import { useClientStore } from '@/stores/client'

definePage({
  meta: {
    action: 'read',
    subject: 'Dashboard',
  },
})

const authStore = useAuthStore()
const clientStore = useClientStore()
</script>

<template>
  <div>
    <VRow>
      <!-- 환영 카드 -->
      <VCol cols="12">
        <VCard>
          <VCardText class="pa-6">
            <div class="d-flex align-center gap-4">
              <VAvatar
                color="primary"
                size="56"
                variant="tonal"
              >
                <VIcon
                  size="32"
                  icon="tabler-user"
                />
              </VAvatar>
              <div>
                <h4 class="text-h4 mb-1">
                  안녕하세요, {{ authStore.userData?.name || '사용자' }}님! 👋
                </h4>
                <p class="text-body-1 mb-0">
                  SV Groupware에 오신 것을 환영합니다.
                </p>
              </div>
            </div>
          </VCardText>
        </VCard>
      </VCol>

      <!-- 선택된 고객사 -->
      <VCol
        v-if="clientStore.selectedClient"
        cols="12"
        md="6"
      >
        <VCard>
          <VCardTitle class="pa-6">
            현재 선택된 고객사
          </VCardTitle>
          <VDivider />
          <VCardText class="pa-6">
            <div class="d-flex align-center gap-4">
              <VAvatar
                color="success"
                size="48"
                variant="tonal"
              >
                <VIcon icon="tabler-building" />
              </VAvatar>
              <div>
                <h5 class="text-h5">
                  {{ clientStore.selectedClient.name }}
                </h5>
                <p class="text-body-2 mb-0">
                  {{ clientStore.selectedClient.code }}
                </p>
              </div>
            </div>
          </VCardText>
        </VCard>
      </VCol>

      <!-- 빠른 링크 -->
      <VCol
        cols="12"
        :md="clientStore.selectedClient ? 6 : 12"
      >
        <VCard>
          <VCardTitle class="pa-6">
            빠른 링크
          </VCardTitle>
          <VDivider />
          <VCardText class="pa-6">
            <VRow>
              <VCol
                cols="6"
                md="3"
              >
                <VBtn
                  block
                  color="primary"
                  variant="tonal"
                  :to="{ name: 'review-client' }"
                  class="py-6"
                >
                  <div class="d-flex flex-column align-center">
                    <VIcon
                      size="24"
                      icon="tabler-building"
                    />
                    <span class="mt-2">고객사 관리</span>
                  </div>
                </VBtn>
              </VCol>
              <VCol
                cols="6"
                md="3"
              >
                <VBtn
                  block
                  color="info"
                  variant="tonal"
                  :to="{ name: 'review-scan' }"
                  class="py-6"
                >
                  <div class="d-flex flex-column align-center">
                    <VIcon
                      size="24"
                      icon="tabler-scan"
                    />
                    <span class="mt-2">리뷰 스캔</span>
                  </div>
                </VBtn>
              </VCol>
              <VCol
                cols="6"
                md="3"
              >
                <VBtn
                  block
                  color="success"
                  variant="tonal"
                  :to="{ name: 'review-upload' }"
                  class="py-6"
                >
                  <div class="d-flex flex-column align-center">
                    <VIcon
                      size="24"
                      icon="tabler-upload"
                    />
                    <span class="mt-2">리뷰 업로드</span>
                  </div>
                </VBtn>
              </VCol>
              <VCol
                cols="6"
                md="3"
              >
                <VBtn
                  block
                  color="warning"
                  variant="tonal"
                  :to="{ name: 'review-tasks' }"
                  class="py-6"
                >
                  <div class="d-flex flex-column align-center">
                    <VIcon
                      size="24"
                      icon="tabler-list-check"
                    />
                    <span class="mt-2">작업 상태</span>
                  </div>
                </VBtn>
              </VCol>
            </VRow>
          </VCardText>
        </VCard>
      </VCol>
    </VRow>
  </div>
</template>
